// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2K2hR","left":"StickyBox_left__2A6K4","right":"StickyBox_right__28033"};